/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const addMyPhoneBodyPhoneNumberMin = 8;
export const addMyPhoneBodyPhoneNumberMax = 32;

export const AddMyPhoneBody = zod.object({
  phoneNumber: zod
    .string()
    .min(addMyPhoneBodyPhoneNumberMin)
    .max(addMyPhoneBodyPhoneNumberMax)
    .describe('The phone number to add as a secondary, in E.164 format'),
});

export type AddMyPhoneBody = zod.input<typeof AddMyPhoneBody>;
export type AddMyPhoneBodyOutput = zod.output<typeof AddMyPhoneBody>;
